import "@mds/resources-web/dist/tokens/components/MdsComponents-cpo.css";
import ChaseWordmark from "./assets/chase-wordmark.svg";
import "./joined-stylesheet.scss";
import {
  EnterOTP,
  ProvideEmailPswd,
  SideBarIllustration,
  ChooseTarget,
  setDynamicCopyright,
} from "./";
import { MdsButton } from "@mds/react";
import { useEffect } from "react";
import { getLoginEndpoint } from "../../../utils/getEndpoints";

const IDLE_TIMEOUT = 25 * 60 * 1000; // 25 minutes

const Login = () => {
  setDynamicCopyright();

  useEffect(() => {
    const idleTimeout = window.setTimeout(() => {
      const loginEndpoint = getLoginEndpoint();
      window.location.href = loginEndpoint;
    }, IDLE_TIMEOUT);

    return () => {
      window.clearTimeout(idleTimeout);
    };
  }, []);

  return (
    <div
      id={"sign-in-container"}
      className="
    show-provide-email-password
    "
    >
      <h1 id={"partner-portal-title"} className={"visuallyhidden"}>
        Chase Partner Portal
      </h1>
      <div id={"desktop-container"}>
        <img
          id="desktop-background-image"
          src={SideBarIllustration}
          alt={""}
          aria-hidden
        />
        <div id={"desktop-content"}>
          <div className="desktop-go-back">
            <MdsButton
              text="Back "
              variant="tertiary"
              id="history-back-button"
              inverse
              iconType="ico_chevron_left"
              onClick={() => window.history.back()}
            />
            <MdsButton
              text="Back "
              variant="tertiary"
              id="dt-back-button"
              inverse
              iconType="ico_chevron_left"
            />
          </div>

          <div id="chase-branding">
            <img src={ChaseWordmark} alt="" />
          </div>
          <h2 id="desktop-greeting" className="headline-small">
            Power your business with Chase APIs
          </h2>
          <p>
            Sign in to view your account and get started exploring our catalog
            of APIs and bundled solutions.
          </p>
        </div>
      </div>

      <div id="content-container">
        <ProvideEmailPswd />
        <ChooseTarget />
        <EnterOTP />
      </div>

      <form id="ping1" action="https://developer.chase.com/" method="POST">
        <input id="ts1" type="hidden" name="ts_token" value="a" />
        <input id="ts2" type="hidden" name="ts_user" value="a" />
        <input id="ts3" type="hidden" name="ts_appid" value="a" />
        <input id="ts4" type="hidden" name="ts_lob" value="a" />
        <input id="ts5" type="hidden" name="ts_click" value="a" />
      </form>
    </div>
  );
};

export default Login;
